<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px" :inline="true">
				<el-form-item label="提现状态:">
					<el-select v-model="listQuery.search.state" clearable placeholder="请选择">
						<el-option label="未审核" value="0"></el-option>
						<el-option label="审核通过" value="1"></el-option>
						<el-option label="审核失败" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单号:">
					<el-input v-model="listQuery.search.order_num" clearable></el-input>
				</el-form-item>
				<el-form-item label="提现时间:">
					<el-date-picker v-model="listQuery.search.start_time" type="date" placeholder="开始日期">
					</el-date-picker>
					-
					<el-date-picker v-model="listQuery.search.end_time" type="date" placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-button type="danger" icon="el-icon-money" @click="tx">申请提现</el-button>
			</el-form>
			<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
			<el-button type="primary" plain @click="resetSearch">重置搜索</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="审核时间:">
								<template>
									<span>{{ props.row.sh_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
								</template>
							</el-form-item>
							<el-form-item v-if="props.row.state == 2" label="失败原因:">
								<span>{{props.row.err_msg}}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="提现时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="money" label="提现金额"> </el-table-column>
				<el-table-column prop="order_num" label="订单号"> </el-table-column>
				<el-table-column prop="type_init" label="账户类型"> </el-table-column>
				<el-table-column prop="account" label="提现账号"> </el-table-column>
				<el-table-column label="提现状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />

			<!-- 提现模态框 -->
			<el-dialog width="30%" title="提现" :visible.sync="is_show_create">
				<span>
					<el-form ref="form" label-width="120px" size="medium">
						<el-form-item label="账户余额:">
							<el-col :span="16">
								<span style="color:red">{{balance}}</span>
							</el-col>
						</el-form-item>
						<el-form-item label="提现账户:">
							<el-col :span="16">
								<el-select v-model="create_data.type" placeholder="请选择">
									<el-option v-for="item in account" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="提现金额">
							<el-col :span="16">
								<el-input-number v-model="create_data.money" :precision="2" :step="100" :min="0.00">
								</el-input-number>
							</el-col>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="tx2">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		withdrawalList,withdrawal
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime,alertMsg
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_create:false,
				create_data:{
					money:0
				},
				balance:'',
				account:[],
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						state: '',
						order_num: '',
						start_time: '',
						end_time: '',
					},
				}
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			getList() { // 获取列表数据
				this.loading = true;
				withdrawalList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					this.loading = false;
					if (this.listQuery.page == 1) {
						this.balance = r.balance;
						this.account = r.account;
					}
				})
			},
			// 提现
			tx(){
				this.is_show_create = true;
			},
			// 申请提现
			tx2(){
				this.$store.commit('setAjaxLoading', true);
				withdrawal(Qs.stringify(this.create_data)).then(response => {
					alertMsg(this, '提交成功,请等待审核', 'success');
					this.is_show_create = false;
					this.create_data = {money:0};
					this.getList();
				})
				
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
